/**
 * Base API Service
 * Base class for API service classes
 */

class BaseApiService {
  constructor(apiClient, baseURL = '') {
    this.apiClient = apiClient;
    this.baseURL = baseURL;
  }

  handleError(error) {
    if (error.response) {
      // Server responded with error
      console.error('API Error:', error.response.data);
      throw new Error(error.response.data.message || 'An error occurred');
    } else if (error.request) {
      // Request made but no response
      console.error('Network Error:', error.request);
      throw new Error('Network error - please check your connection');
    } else {
      // Something else happened
      console.error('Error:', error.message);
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }

  async get(url, config = {}) {
    try {
      const response = await this.apiClient.get(url, config);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  async post(url, data = {}, config = {}) {
    try {
      const response = await this.apiClient.post(url, data, config);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  async put(url, data = {}, config = {}) {
    try {
      const response = await this.apiClient.put(url, data, config);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  async patch(url, data = {}, config = {}) {
    try {
      const response = await this.apiClient.patch(url, data, config);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  async delete(url, config = {}) {
    try {
      const response = await this.apiClient.delete(url, config);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }
}

export default BaseApiService;

